
import { computed, defineComponent, PropType } from 'vue-demi';
import { colorTypographyToken } from '../enums';
import '../AdmTypography/typography.scss';

const __default__ = defineComponent({
  name: 'adm-symbol',
  emits: ['click'],
  props: {
    name: {
      type: String,
      required: true,
      validator(value: string) {
        return /[a-z0-9]{1,}_(fill1_)?(20|24|40|48)px$/gm.test(value);
      },
    },
    color: {
      type: String as PropType<colorTypographyToken>,
      required: false,
    },
  },
  setup(props) {
    return {
      size: computed(() => props.name.split('_').at(-1)),
    };
  },
});

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars((_vm, _setup) => ({
  "22881d4d": (_vm.size)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__